import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { useWizard } from "react-use-wizard";
import Steps from "../steps/Steps";
import * as GrIcons from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { stepActions } from "../../store/Steps";
import { variants } from "../../shared/variants";
import { britamInsurer } from "../../enums/appNums";
import { useMixpanel } from "react-mixpanel-browser";
import { isStandardInurance } from "../../shared/currency-formatter/utils";
import { useTranslation } from "react-i18next";

function PrepareDocuments() {
  const { t } = useTranslation();
  const mixpanel = useMixpanel()
  const { previousStep, nextStep, goToStep } = useWizard();
  const quote = JSON.parse(sessionStorage.getItem("quote")!);
  const insurer = quote?.insurer;
  const SKEY = sessionStorage.getItem("SKEY")!;
  const tenantCreds = useSelector((state: any) => state.tenantCreds);
  const isStandard = useMemo(() => isStandardInurance(tenantCreds?.domain), [tenantCreds?.domain]);
  const dispatch = useDispatch();
  const getToPreviousScreen = () => {
    if (SKEY) {
      if (dispatch(stepActions.onRemoveStepUpto(2))) {
        goToStep(2);
      }
    } else {
      if (dispatch(stepActions.onRemoveStep())) {
        previousStep();
      }
    }
  };

  useEffect(() => {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Prepare-documents",
      });
    }
  }, [mixpanel])

  return (
    <motion.div variants={variants} initial="enter" animate="center">
      <Steps name="prepare" />
      <div className="container">
        <div className="title">
          <div className="prepare-title span-title">
            {t("prepareDocuments.buyInsuranceHeader")}
          </div>
          <div className="prepare-title-2">
            {t("prepareDocuments.readyDocs")}
          </div>
        </div>
        <div className="prepare-details">
          <ul>
            <li>{t("prepareDocuments.nationalIdPassport")}</li>
            {insurer == britamInsurer && <li>{t("prepareDocuments.taxCertificate", { type: isStandard ? "TIN" : "KRA PIN" })}</li>}
            {quote?.policy?.reason == "STUDIES" && <li>{t("prepareDocuments.proofOfSchooling")}</li>}
          </ul>
        </div>
        <div className="prepare-details-btn text-center">
          <button
            className="pointer-btn"
            onClick={() => {
              if (dispatch(stepActions.onAddStep())) {
                nextStep();
              }
            }}
          >
            {t("prepareDocuments.letsProceed")}
          </button>
        </div>
        <div className="previous">
          <span onClick={getToPreviousScreen}>
            <span className="GrIcon me-2">
              <GrIcons.GrFormPreviousLink />
            </span>{" "}
            <span className="previous">{t("prepareDocuments.previous")}</span>
          </span>
        </div>
      </div>
    </motion.div>
  );
}

export default PrepareDocuments;
